import * as React from 'react';

import { StyleButton } from './StyleButton';

export const BLOCK_TYPES = [
  { style: 'header-one', icon: 'editor-h1' },
  { style: 'header-two', icon: 'editor-h2' },
  { style: 'header-three', icon: 'editor-h3' },
  { style: 'header-four', icon: 'editor-h4' },
  // blockquote is not supported properly by `draft-js-import-markdown`
  // { style: 'blockquote', icon: 'editor-blockquote' },
  { style: 'unordered-list-item', icon: 'editor-list-bullets' },
  { style: 'ordered-list-item', icon: 'editor-list-numbered' }
];

type Props = {
  editorState: any,
  onToggle: (a: string) => void
};

class BlockStyleControls extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { editorState, onToggle } = this.props;
    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    return (
      <section className="rich-text-editor__buttons">
        {
          BLOCK_TYPES.map((type) =>
            <StyleButton
              key={type.style}
              active={type.style === blockType}
              type={type}
              onToggle={onToggle}
            />
          )
        }
      </section>
    );
  }
}

export default BlockStyleControls;
